// extracted by mini-css-extract-plugin
export default {"questionContainer":"AKAsSection_questionContainer__uMIEY"};